<template>
  <div class="login-container">
    <el-form 
      autoComplete="on" 
      :model="loginForm"  
      size='default' 
      :rules="loginRules" 
      ref="loginForm" 
      class="card-box login-form">
      <h3 class="title">{{$store.state.system.title || $t('system.title')}}</h3>
      <el-form-item prop="username">
        <el-input name="username"   type="text" v-model.trim="loginForm.username" autoComplete="on" :placeholder="$t('system.username')" />
      </el-form-item>
      <el-form-item prop="password" class="password-box">
        <el-input name="password"  :type="pwdType" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="on"
        :placeholder="$t('system.password')"></el-input>
      </el-form-item>
      <el-form-item class="btn">
          <el-button class="btn-login" type="primary" :loading="loading" @click.native.prevent="handleLogin">{{$t('system.login')}}</el-button>
      </el-form-item>
    </el-form>
    <div class="foot_copy" v-html="$store.state.system.copyright"></div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    // 密码校验 长度不能小于8位且不能大于20位字符,必须包含大写字母、小写字母、数字和特殊符号
    // var ISPWD =/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\._\+(){}])[0-9a-zA-Z!@#$%^&*,\\._\+(){}]{8,20}$/;

    // 密码校验 密码长度8-20个字(大写字母、小写字母、数字、特殊字符至少两项！)
    var ISPWD_HCKJ =/^(?![\d]+$)(?![a-z]+$)(?![A-Z]+$)(?![\W_]+$)[\da-zA-z\W_]{8,20}$/;
    var ISPWD =/^.{6,20}$/;
	  // 密码校验
    const validatePassword = (rule, value, callback) =>{
      if(this.loginForm.username=='HCKJ'){
        if (!ISPWD_HCKJ.test(this.loginForm.password)) {
          callback(new Error(this.$t('system.password_tip1')));
        } else {
          callback();
        }
      } else {
        if (!ISPWD.test(this.loginForm.password)) {
          callback(new Error(this.$t('system.password_tip2')));
        } else {
          callback();
        }
      }
      
    }
    return {      
      loginForm: {
        login_type: 1,
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', message: this.$t('system.please_username') },
          { min: 4, max: 11, message: this.$t('system.username_tip'), trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur', message: this.$t('system.password_tip3') },
          // { min: 8, max: 20, message: '密码长度在 8 - 20 个字', trigger: 'blur' },
          { required: true, validator: validatePassword, trigger: 'blur' }
        ]
      },
      loading: false,
      redirect: undefined,
      pwdType: 'password',
      isLogin: 0
    }
  },
  async created(){
    let isLogin=this.$route.query.isLogin;
    let user=this.$route.query.user;
    this.redirect=this.$route.query.redirect;
    if(isLogin) {
      if(!user){
        this.$message.error(this.$t('system.username_tip'));
        return
      }
      this.isLogin = isLogin
      this.noLogin()
    }
  },
  methods: {
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    noLogin() {
      let noLoginData = {
        username: this.$route.query.user,
        password: 'a12345678'
      }
      this.loading = true
      this.$store.dispatch('login', noLoginData).then((res) => {
        this.loading = false
        if(res.code==1000){
          if(this.redirect&&this.redirect!=undefined){
            this.$router.push({ path: this.redirect || '/index' })
          }else{
            this.$router.push({ path: '/index' })
          }
        }else{
          return this.$message({
            message: res.message || this.$t('system.error'),
            type: 'error',
            duration: 3 * 1000
          });
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          if (this.loginForm.password === this.loginForm.username || this.loginForm.password === this.loginForm.username.split('').reverse().join('')) {
            return this.$message({
              message: this.$t('system.password_tip4'),
              type: 'error',
              duration: 3 * 1000
            });
          }

          this.loading = true
          this.$store.dispatch('login', this.loginForm).then((res) => {
            this.loading = false
            if(res.code==1000){
              this.$router.push({ path: this.redirect || '/device/lamps' });
            }else{
              return this.$message({
                message: res.message || this.$t('system.error'),
                type: 'error',
                duration: 3 * 1000
              });
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    }

  }
}
</script>
<style lang="less">
  @dark_gray:#889aa4;
  @light_gray:#eee;
  @active:#85e6fc;
  .login-container {
    position: fixed;
    height: 100%;
    width:100%;
    background:url('../assets/home_images/login_bg.jpg') no-repeat;
    background-size: cover;
    left:0;
    top:0;
    right:0;
    bottom:0;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      -webkit-appearance: none;
      height: 40px;
    }
    .el-input__inner{
      color:#000 !important
    }
    .el-input__inner::placeholder{
      color:#777 !important
    }
    .password-box{
      height:50px;
      align-items: flex-start;
    }


    .login-form {
      border-radius: 5px;
      background-clip: padding-box;
      width: 400px;
      margin: 0 auto;
      padding: 25px 40px 25px;
      background-color: rgba(255,255,255,.6);
      border: 1px solid rgba(255,255,255,.8);
    }
    .title {
      margin: 12px auto 20px;
      text-align: center;
      font-size: 24px;
      color: #000;
    }
    .btn {
      text-align: center;
    }
    .btn-login {
      width: 100%;
      padding: 12px 20px;
      background-color: #336b96;
      border-color: #336b96;
      height: auto;
      font-size: 16px;
    }
    .foot_copy{
      width:100%;
      height:30px;
      bottom: 10px;
      color: #fff;
      text-align: center;
      position: absolute;
      z-index: 999;  
      left:0;
      font-size:14px;
    }
    .foot_copy a{
      color:#fff;
      font-weight: bold;
      display:inline-block;
    }
    .el-form-item__content{
      height:auto;
    }
  }
</style>
